/**
 * @file The enumerator RepeatValidation is used as return value for the Repeat.validateWith method.
 * @author Tom Verschoore de la Houssaije
 */
/** The enumerator RepeatValidation is used as return value for the Repeat.validateWith method. */
export var RepeatValidation;
(function (RepeatValidation) {
    /** Match between start and repeat. */
    RepeatValidation[RepeatValidation["Ok"] = 0] = "Ok";
    /** Day of week mismatch between start and repeat. */
    RepeatValidation[RepeatValidation["WeekDayMismatch"] = 1] = "WeekDayMismatch";
    /** Occurrence of day of week within month mismatch between start and repeat. */
    RepeatValidation[RepeatValidation["OccurrenceOrderMismatch"] = 2] = "OccurrenceOrderMismatch";
    /** Date mismatch between start and repeat. */
    RepeatValidation[RepeatValidation["DateMismatch"] = 4] = "DateMismatch";
    /** Month mismatch between start and repeat. */
    RepeatValidation[RepeatValidation["MonthMismatch"] = 8] = "MonthMismatch";
    /** UntilDate before Start  */
    RepeatValidation[RepeatValidation["UntilDateBeforeStart"] = 16] = "UntilDateBeforeStart";
})(RepeatValidation || (RepeatValidation = {}));
